function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 0a4 4 0 014 4v2h2a1 1 0 011 1v8a1 1 0 01-1 1H2a1 1 0 01-1-1V7a1 1 0 011-1h2V4a4 4 0 014-4zm0 9a1 1 0 00-.993.883L7 10v2a1 1 0 001.993.117L9 12v-2a1 1 0 00-1-1zM6 4a2 2 0 114 0v2H6V4z",
  fill: "#243143"
});

function SvgInternetAccess16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDBDMTAuMjA5MSAwIDEyIDEuNzkwODYgMTIgNFY2SDE0QzE0LjU1MjMgNiAxNSA2LjQ0NzcyIDE1IDdWMTVDMTUgMTUuNTUyMyAxNC41NTIzIDE2IDE0IDE2SDJDMS40NDc3MiAxNiAxIDE1LjU1MjMgMSAxNVY3QzEgNi40NDc3MiAxLjQ0NzcyIDYgMiA2SDRWNEM0IDEuNzkwODYgNS43OTA4NiAwIDggMFpNOCA5QzcuNDg3MTYgOSA3LjA2NDQ5IDkuMzg2MDQgNy4wMDY3MyA5Ljg4MzM4TDcgMTBWMTJDNyAxMi41NTIzIDcuNDQ3NzIgMTMgOCAxM0M4LjUxMjg0IDEzIDguOTM1NTEgMTIuNjE0IDguOTkzMjcgMTIuMTE2Nkw5IDEyVjEwQzkgOS40NDc3MSA4LjU1MjI4IDkgOCA5Wk02IDRDNiAyLjg5NTQzIDYuODk1NDMgMiA4IDJDOS4xMDQ1NyAyIDEwIDIuODk1NDMgMTAgNFY2SDZWNFoiIGZpbGw9IiMyNDMxNDMiLz4KPC9zdmc+Cg==";
export { SvgInternetAccess16 as ReactComponent };